// custom theme
export const theme = {
    colors: {
        primary: {
            dark: '#1A1A1B',
            light: '#94F3E4'
        },
        secondary: {
            dark: '#333F44',
            light: '#37AA9C'
        },
        text: {
            light: '#ccd6f6',
            dark: '#8892b0'
        }
    }
} 